module.exports = __webpack_public_path__ + "img/我的预约单.3795266c.png";